export default __webpack_public_path__ + "static/media/lens_small_logo.97a51e16.svg";